import * as React from "react";
import { Text, IconButton, HStack, Flex } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useSelector, useOnline } from "duck";
import { Form } from "./components";

interface CaseNameProps {
  name: string;
  createdFrom: { name: string; _id: number } | null;
}

const CaseName: React.FC<CaseNameProps> = ({ name, createdFrom }) => {
  const online = useOnline();
  const [edit, setEdit] = React.useState(false);
  const hasCachedCase = useSelector(({ cases }) => {
    if (!createdFrom) {
      return false;
    }
    return !!cases[createdFrom._id];
  });

  if (edit) {
    return <Form defaultName={name} onFinish={() => setEdit(false)} />;
  }

  return (
    <Flex direction="column">
      <HStack spacing={2} alignItems="center">
        <Text
          color="gray.700"
          fontWeight={600}
          fontSize="2xl"
          lineHeight="40px"
        >
          {name}
        </Text>
        <IconButton
          onClick={() => setEdit(true)}
          variant="unstyled"
          aria-label="Edit"
          size="2xs"
          icon={<BiEditAlt />}
        />
      </HStack>
      {createdFrom && (
        <Text fontSize="sm">
          Case was created from{" "}
          {online || hasCachedCase ? (
            <Link
              style={{ fontWeight: 600 }}
              to={`/cases/${createdFrom._id}/check-in`}
            >
              {createdFrom.name}
            </Link>
          ) : (
            createdFrom.name
          )}
        </Text>
      )}
    </Flex>
  );
};

export default CaseName;
